import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawLookingForSomethingIcon from "./RawLookingForSomethingIcon.svg.jsx";

const LookingForSomethingIcon = forwardRef((props, ref) => {
  return (
    <Icon ref={ref} SvgComponent={RawLookingForSomethingIcon} {...props} />
  );
});

export default LookingForSomethingIcon;
